import React from 'react';
import Icon from '../../icon/icon';

const NavigationButton = (props) => {
  return (
    <div className="navigation-btn">
      <div>{props.label}</div>
      {props.iconName && <Icon name={`far ${props.iconName}`} />}
    </div>
  );
};

export default NavigationButton;
